<div class="h-full w-full zmain-bg p-4">
  <form
    [formGroup]="contactUsForm"
    (ngSubmit)="onSubmit()"
    class="w-full flex flex-col items-center pb-3"
    >
    <mat-form-field class="w-full">
      <mat-label>Contact Name</mat-label>
      <input matInput formControlName="contactName" />
    </mat-form-field>
    <mat-form-field class="w-full">
      <mat-label>Company Name</mat-label>
      <input matInput formControlName="companyName" />
    </mat-form-field>

    <mat-form-field class="w-full">
      <mat-label>Subject</mat-label>
      <input matInput formControlName="subject" />
    </mat-form-field>

    <div
      class="flex flex-row laptop-max:flex-wrap justify-between gap-2 w-full"
      >
      <mat-form-field class="w-1/2 laptop-max:w-full">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" />
      </mat-form-field>
      <mat-form-field class="w-1/2 laptop-max:w-full">
        <mat-label>Phone Number</mat-label>
        <input matInput type="number" formControlName="phone" />
      </mat-form-field>
    </div>

    <mat-form-field class="w-full">
      <mat-label>Message</mat-label>
      <textarea matInput formControlName="message"></textarea>
    </mat-form-field>
    <button
      color="primary"
      class="counter-btn text-xs text-center"
      mat-stroked-button
      [disabled]="contactUsForm.invalid"
      [ngClass]="{ 'disabled-btn': contactUsForm.invalid }"
      >
      Contact
    </button>
  </form>
  @if (isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
</div>
